import React from 'react'
import PropTypes from 'prop-types'

import { Link } from '@aok/ui-elements'
import { ArrowRoundedRightup } from '@aok/icon-functional'

const OfferSearchInfoLink = ({ url, className }) => {
  return (
    <Link
      className={className}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      icon={<ArrowRoundedRightup className="h-16 w-16 fill-current ml-4" />}
      title="Zur Webseite"
      variant="structure"
    />
  )
}

OfferSearchInfoLink.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
}

OfferSearchInfoLink.defaultProps = {
  className: '',
}

export default OfferSearchInfoLink
